<script setup>
import { watch, getCurrentInstance } from 'vue'
import { useAsyncState } from '@vueuse/core'
import FormControlTypeRelationshipOneToMany from '../../common/form-control-type/FormControlTypeRelationshipOneToMany'

const props = defineProps({
    formId: String,
    field: Object,
    currentData: Object,
})

const { proxy } = getCurrentInstance()
const store = proxy.$store

const toggleField = (name, show) => {
    const fields = store.state[props.formId]?.fields
    const field = fields?.find(o => o.columnName === name)

    if (field) {
        field.hidden = !show
    }

    if (!show) {
        if (name === 'schoolId' && props.currentData[name]) {
            props.currentData[name] = 0
        } else if (name === 'location' && props.currentData[name]) {
            props.currentData[name] = ''
        }
    }
}

const updateVisibility = (courseType) => {
    if (courseType === 'After school club') {
        toggleField('location', false)
        toggleField('schoolId', true)
    } else if (courseType) {
        toggleField('location', true)
        toggleField('schoolId', false)
    } else {
        // Only hide everything if courseType is explicitly null/false
        // (i.e., no course selected)
        toggleField('location', false)
        toggleField('schoolId', false)
    }
}

const { state: courseType, execute, isLoading } = useAsyncState(
    async () => {
        if (!props.currentData.courseId) return null

        const obj = await store.dispatch('itemData/get', {
            tableName: 'odp_courses',
            id: props.currentData.courseId,
        })
        return obj.courseType
    },
    null,
    { immediate: true }
)

watch(() => props.currentData.courseId, (newId) => {
    if (!newId) {
        courseType.value = null
        updateVisibility(null)
    } else {
        execute()
    }
})

/**
 * FIXED WATCHER
 */
watch(courseType, (newType) => {
    // 1. If we are currently loading, do nothing.
    // This prevents the initial 'null' from wiping data before the API responds.
    if (isLoading.value) return

    // 2. If we have a type, or if the ID is missing (newType is null), update.
    updateVisibility(newType)
}, { immediate: true })
</script>

<template>
    <FormControlTypeRelationshipOneToMany
        :current-data="currentData"
        :field="field"
        :form-id="formId"
    />
</template>